import { Injectable } from '@angular/core';
import { PocketbaseService } from './pocketbase.service';
import { Test } from '../interfaces/testInterface';
import { TestResult } from '../interfaces/questionInterface';
import { ListResult } from 'pocketbase';
import { QuestionService } from './question.service';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  constructor(private readonly pocketbaseService: PocketbaseService) { }

  async createTest(examId: string): Promise<Test> {
    const test = await this.pocketbaseService.pb.send(`/test/${examId}`, { method: 'POST' });
    return test;
  }

  async getOneTest(testId: string): Promise<Test> {
    const record = await this.pocketbaseService.pb.collection('tests').getOne<Test>(testId, {
      expand: 'questions, questions.answer_options, conditions'
    });

    return record;
  }

  async getTestResults(testId: string): Promise<TestResult> {
    const record = await this.pocketbaseService.pb.send<TestResult>(`/test-results/${testId}`, { method: 'GET' });
    return record;
  }

  async getUserTestResults(examId?: string, page?: number, perPage?: number): Promise<ListResult<TestResult>> {
    if (this.pocketbaseService.pb.authStore.model != null) {
      const userId = this.pocketbaseService.pb.authStore.model['id'];

      if (!userId) {
        throw new Error('Not logged in');
      }

      if(examId){
        return await this.pocketbaseService.pb.send<ListResult<TestResult>>(`/test-results/user/${userId}`, { method: 'GET', query: { page, perPage, exam_id: examId }});
      } else {
        return await this.pocketbaseService.pb.send<ListResult<TestResult>>(`/test-results/user/${userId}`, { method: 'GET', query: { page, perPage }});
      }
    }

    throw new Error('Not logged in');
  }
}
